import { AxiosError } from "axios";

// Matched on status: the 404 body carries the generic INVALID_REQUEST code.
export const isNotFoundError = (error: unknown): boolean =>
  error instanceof AxiosError && error.response?.status === 404;
